import { MemberGroups } from "shared-types";
import { config } from "../../../config/common";
import { aboutYouInitialFormValues } from "./AboutYouPageCD/constants";
import { AboutYouFormProps } from "./AboutYouPageCD/types";
import {
  WelcomePageFormFields,
  welcomePageFormInitialFields,
} from "./WelcomePageCD/welcomePageValidation";

export enum ICDApplicationPage {
  Welcome = "welcome",
  AboutYouPage = "about-you",
}

export interface ICDFormValues {
  [ICDApplicationPage.Welcome]: WelcomePageFormFields;
  [ICDApplicationPage.AboutYouPage]: AboutYouFormProps;
}

export type FormProps = AboutYouFormProps | WelcomePageFormFields;

export const applicationCDFromDataInitialValues = {
  [ICDApplicationPage.Welcome]: welcomePageFormInitialFields,
  [ICDApplicationPage.AboutYouPage]: aboutYouInitialFormValues,
};

export const cdBrazeProps = {
  memberGroupFromToken: MemberGroups.castingDirector,
  portalId: "",
  brazeConfig: {
    apiKey: config.braze.apiKey,
    baseUrl: config.braze.baseUrl,
  },
};
